import { render } from "./PurchaseManage.vue?vue&type=template&id=58954bc1&scoped=true"
import script from "./PurchaseManage.vue?vue&type=script&lang=js"
export * from "./PurchaseManage.vue?vue&type=script&lang=js"

import "./PurchaseManage.vue?vue&type=style&index=0&id=58954bc1&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58954bc1"]])

export default __exports__